<!-- 省市区三级联动 -->
<template>
  <div class="region">
    <el-select v-model="province" style="width:150px">
      <el-option v-for="(key,value) in provinceData" :key="value" :value="value"></el-option>
    </el-select>
    <el-select v-model="city" style="width:150px;margin-left:20px;">
      <el-option v-for="(key,value) in cityData" :key="value" :value="value"></el-option>
    </el-select>
    <el-select v-model="area" style="width:150px;margin-left: 20px;">
      <el-option v-for="item in areaData" :key="item" :value="item"></el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  name: "Region",
  components: {},
  props: ["areaSelect"],
  data() {
    let province = "北京市";
    let city = "北京市";
    let area = "朝阳区";
    if (this.areaSelect && this.areaSelect.length > 0) {
      province = this.areaSelect[0];
      city = this.areaSelect[1];
      area = this.areaSelect[2];
    }
    return {
      provinceData: {}, // 省级
      cityData: {}, // 市
      areaData: [], // 区
      province: province, // 省级
      city: city, // 市
      area: area // 区
    };
  },
  watch: {
    province(value) {
      this.cityData = this.provinceData[value];
      for (let key in this.cityData) {
        this.city = key;
        break;
      }
    },
    city(value) {
      this.areaData = this.cityData[value];
      this.area = this.areaData[0];
      this.$emit("getRegion", [this.province, this.city, this.area]);
    },
    area(value) {
      this.$emit("getRegion", [this.province, this.city, this.area]);
    }
  },
  mounted() {
    this.provinceData = Region; // 这个是在pubilc/index.html 里面引入的
    if (this.areaSelect && this.areaSelect.length > 0) {
      this.cityData = this.provinceData[this.areaSelect[0]];
      this.areaData = this.cityData[this.areaSelect[1]];
    } else {
      // 默认北京
      this.cityData = this.provinceData["北京市"];
      this.areaData = this.cityData["北京市"];
    }
    this.$emit("getRegion", [this.province, this.city, this.area]);
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.region {
  select {
    padding-left: 10px;
    cursor: pointer;
    border-radius: 5px;
    width: 150px;
    height: 40px;
    margin-right: 20px;
    font-size: 14px;
    border: 1px solid @border3Color;
  }
}
</style>
